import { AgentDTO } from './selectAgents';
import { CrystalDrawing } from 'components/well/drawingManager/constants';

export const useCrystalCryos = (crystal: CrystalDrawing) => {
  return crystal.cryoprotectants?.map(
    (cryo) =>
      ({
        id: cryo.id,
        label:
          cryo.ingredient +
          (cryo.conc ? ', ' + cryo.conc + cryo.concUnit : '') +
          (cryo.ph ? ', pH ' + cryo.ph : ''),
        checked: true,
      } as AgentDTO),
  );
};

export const useCrystalSoakings = (crystal: CrystalDrawing) => {
  return crystal.soakings?.map(
    (soaking) =>
      ({
        id: soaking.id,
        label:
          soaking.ingredient +
          (soaking.conc ? ', ' + soaking.conc + soaking.concUnit : '') +
          (soaking.time ? ', ' + soaking.time + soaking.timeUnit : ''),
        checked: true,
      } as AgentDTO),
  );
};
